import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/corpdrivee/_sidebar-layout/documents')({
    component: () => <div>Hello /_dashboard/corpdrivee/_sidebar-layout/documents!</div>,
})
